'use strict';

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

var React = require('react');
var useScroll = require('react-router-scroll/lib/useScroll');

var _require = require('react-redux'),
    Provider = _require.Provider;

var _require2 = require('react-router'),
    Router = _require2.Router,
    useRouterHistory = _require2.useRouterHistory,
    applyRouterMiddleware = _require2.applyRouterMiddleware,
    match = _require2.match;

var _require3 = require('history'),
    createHistory = _require3.createHistory;

var _require4 = require('redial'),
    trigger = _require4.trigger;

var find = function find() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var predicate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return false;
  };

  if (!array.length) return;

  var _array = _toArray(array),
      head = _array[0],
      tail = _array.slice(1);

  if (predicate(head)) return head;

  return find(tail, predicate);
};

var _require5 = require('../shared'

// ClientAppDefinition {
//   store = ReduxStore,
//   routes = ReactRouterRoutes,
//   history = ReactRouterHistory,
//   createLocals = ReactRouterParams -> ReduxStore -> Locals,
//   onRouteError = Error -> reactRouterRedirect -> ()
// }

// createClientApp :: ClientAppDefinition -> ClientAppElement

),
    defaultCreateLocals = _require5.defaultCreateLocals,
    defaultStore = _require5.defaultStore,
    ensureRoutes = _require5.ensureRoutes;

var onLocationChange = function onLocationChange(_ref) {
  var store = _ref.store,
      routes = _ref.routes,
      basepath = _ref.basepath,
      createLocals = _ref.createLocals,
      onRouteError = _ref.onRouteError,
      onRouteRedirect = _ref.onRouteRedirect;
  return function (location) {
    match({ routes: routes, location: location, basename: basepath }, function (error, redirect, props) {
      if (error) {
        return onRouteError(error);
      } else if (redirect) {
        return onRouteRedirect(redirect);
      } else if (!props) {
        return onRouteError(new Error('Not found: Route ' + location.pathname + ' failed to match'));
      }

      var params = props.params,
          components = props.components,
          location = props.location;
      var query = location.query;

      var locals = createLocals({ params: params, store: store, query: query });

      trigger('fetch', components, locals);
      trigger('defer', components, locals);
    });
  };
};

module.exports = function (_ref2) {
  var _ref2$store = _ref2.store,
      store = _ref2$store === undefined ? defaultStore() : _ref2$store,
      _ref2$routes = _ref2.routes,
      routes = _ref2$routes === undefined ? ensureRoutes('createClientApp') : _ref2$routes,
      _ref2$basepath = _ref2.basepath,
      basepath = _ref2$basepath === undefined ? '' : _ref2$basepath,
      _ref2$history = _ref2.history,
      history = _ref2$history === undefined ? createHistory() : _ref2$history,
      _ref2$createLocals = _ref2.createLocals,
      createLocals = _ref2$createLocals === undefined ? defaultCreateLocals : _ref2$createLocals,
      _ref2$onRouteError = _ref2.onRouteError,
      onRouteError = _ref2$onRouteError === undefined ? function () {} : _ref2$onRouteError,
      _ref2$onRouteRedirect = _ref2.onRouteRedirect,
      onRouteRedirect = _ref2$onRouteRedirect === undefined ? function () {} : _ref2$onRouteRedirect;

  var basedHistory = useRouterHistory(function () {
    return history;
  })({
    basename: basepath
  });

  var locationChangeHandler = onLocationChange({
    store: store,
    routes: routes,
    createLocals: createLocals,
    onRouteError: onRouteError,
    onRouteRedirect: onRouteRedirect
  });

  basedHistory.listen(locationChangeHandler);

  if (basedHistory.getCurrentLocation) {
    var initialLocation = basedHistory.getCurrentLocation();
    locationChangeHandler(initialLocation);
  }

  var scrollBehaviourMiddleware = useScroll(function (prevRouterProps, routerProps) {
    var scrollToAnchor = function scrollToAnchor(prevRouterProps, _ref3) {
      var location = _ref3.location;

      if (location.hash) {
        try {
          var e = document.querySelector(location.hash);

          if (e) {
            e.scrollIntoView();
            return false;
          }
        } catch (e) {
          return true;
        }
      }
      return true;
    };
    var scrollBehaviourRoute = find(routerProps.routes, function (route) {
      return route.scrollBehaviour;
    });
    var customScrollBehaviour = scrollBehaviourRoute ? scrollBehaviourRoute.scrollBehaviour : scrollToAnchor;
    return customScrollBehaviour(prevRouterProps, routerProps);
  });

  return function () {
    return React.createElement(Provider, { store: store }, React.createElement(Router, {
      history: basedHistory,
      routes: routes,
      render: applyRouterMiddleware(scrollBehaviourMiddleware)
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/boiler-room-runner/dist/client/index.js
// module id = 871
// module chunks = 0